import * as React from "react";
import PdfSvg from "../../../assets/icons/svgIcons/pdfSvg";
import { apiService } from "../../service/apiService";
import DeviceContext from "./../../service/indentifyDevice";
import { config } from "../../../config/domain";
import Loader from "../../generic/loader";

export interface IStructuredProdScrnProps {}

interface IContact {
	comp: string; // bold text at top
	addr: string;
	name?: string;
	website?: string[];
	phone?: string[];
	fax?: string[];
	email?: string[];
}

interface IContactInfoDeb {
	comp: string; // bold text at top
	addr: string;
	name?: string;
	website?: string[];
	phone?: string[];
	fax?: string[];
	email?: string[];
	cPerson?: string;
	SRegNum?:string;
	Cin?:string;
}
interface IReport {
	ID: number;
	FilePathName: string;
	RatingAgencyName: string;
}

const StructuredProdScrn: React.FC<IStructuredProdScrnProps> = () => {
	const [styles, setStyles] = React.useState({} as any);
	const [reports, setReports] = React.useState<Array<IReport>>([]);
	const investorContact: IContact = {
		comp: "Dipankar Basu – Company Secretary",
		addr: "Edelweiss House,<br/>Off CST Road, Kalina,<br/>Mumbai – 400098",
		phone: [ "+91 22 4009 4400"],
		fax:["+ 91 22 4086 3610"],
		email:["NWM.Secretarial@nuvama.com"]
	};
	const DebTrustee: IContactInfoDeb = {
		comp: "Catalyst Trusteeship Limited",
		addr: "Windsor, 6th Floor, Office No.604, C.S.T. Road,<br/>Kalina, Santacruz (East)<br/>Mumbai – 400098",
		phone: [ "+91 022 4922 0555"],
		fax:["+91 022 4922 0505"],
		email:["dt@cltrustee.com"],
		cPerson : "Mr. Umesh Salvi",
		SRegNum : "SEBI Registration No : IND000000034",
		Cin: "CIN : U74999PN1997PLC110262"
	};

	React.useEffect(() => {
		if (DeviceContext().isMobile) {
			import("../../../assets/scss/components/footer/structuredProduct/structuredProdMob.module.scss").then((style) => {
				setStyles(style.default);
			});
		} else {
			import("../../../assets/scss/components/footer/structuredProduct/structuredProdDsk.module.scss").then((style) => {
				setStyles(style.default);
			});
		}
	}, []);

	const contactDebCard = (contact: IContactInfoDeb) => (
		<>
			<h3 className={styles.h3}>{contact.comp}</h3>
			<p dangerouslySetInnerHTML={{ __html: contact.addr }} className={styles.para} />
			{contact.name && (
				<p className={[styles.para, styles.user_data].join(" ")}>
					<i className="edel-icon-user1" />
					{contact.name}
				</p>
			)}
			{contact.website?.map((website) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={website}>
					<a href={website}>
						<i className="edel-icon-website" />
						{website}
					</a>
				</p>
			))}
			{contact.phone?.map((phone) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={phone}>
					<i className="edel-icon-phone1" />
					{phone}
				</p>
			))}
			{contact.fax?.map((fax) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={fax}>
					<i className="edel-icon-fax" />
					{fax}
				</p>
			))}
			{contact.email?.map((email) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={email}>
					<a href={"mailto:" + email}>
						<i className="edel-icon-email" />
						{email}
					</a>
				</p>
			))}
			{contact.cPerson && (
				<p className={[styles.para, styles.user_data].join(" ")}>
					{"Contact Person  "}
					<i className="edel-icon-user1" />
					{": " + contact.cPerson}
				</p>
			)}
			{contact.SRegNum && (
				<p className={[styles.para, styles.user_data].join(" ")}>
					{contact.SRegNum}
				</p>
			)}
			{contact.Cin && (
				<p className={[styles.para, styles.user_data].join(" ")}>
					{contact.Cin}
				</p>
			)}
		</>
	);

	React.useEffect(() => {
		apiService(
			{
				url: config.web_mw + "Broking/GetFileUpload",
				method: "GET"
			},
			getFilesSuccess
		);
	}, []);

	function getFilesSuccess(res: Array<IReport>) {
		setReports(res);
	}

	const contactCard = (contact: IContact) => (
		<>
			<h3 className={styles.h3}>{contact.comp}</h3>
			<p dangerouslySetInnerHTML={{ __html: contact.addr }} className={styles.para} />
			{contact.name && (
				<p className={[styles.para, styles.user_data].join(" ")}>
					<i className="edel-icon-user1" />
					{contact.name}
				</p>
			)}
			{contact.website?.map((website) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={website}>
					<a href={website}>
						<i className="edel-icon-website" />
						{website}
					</a>
				</p>
			))}
			{contact.phone?.map((phone) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={phone}>
					<i className="edel-icon-phone1" />
					{phone}
				</p>
			))}
			{contact.fax?.map((fax) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={fax}>
					<i className="edel-icon-fax" />
					{fax}
				</p>
			))}
			{contact.email?.map((email) => (
				<p className={[styles.para, styles.user_data].join(" ")} key={email}>
					<a href={"mailto:" + email}>
						<i className="edel-icon-email" />
						{email}
					</a>
				</p>
			))}
		</>
	);

	return Object.keys(styles).length ? (
		<div className={styles.struct_prod + " mg-t40 mg-b40"}>
			<h1 className={styles.h1 + (DeviceContext().isDesktop ? " " + styles.title : "")}>Valuations of Structured Products</h1>
			<h2 className={styles.h3}>Nuvama Wealth and Investment Limited</h2>
			<p className={styles.para}>
				Nuvama Wealth and Investment Ltd. is a subsidiary company of Nuvama Wealth Management Limited. Edelweiss Financial Services Limited (EFSL) is the
				parent company of Nuvama Wealth Management Limited. Nuvama Wealth and Investment Limited Offers Broking, Advisory and DP services under SEBI
				Registration No.: INZ000005231 (Member of NSE, BSE and MSE) and IN-DP-NSDL-314-2009 (DP with NSDL).
			</p>
			<p className={styles.para}>
				The Company is registered as a trading member with National Exchange of India Limited (‘NSEIL’), BSE Limited (‘BSE’) and Metropolitan
				Stock Exchange of India Limited (MSEI), Multi-commodity Exchange of India Limited (MCX), National Commodity and Derivatives Exchange
				Limited (NCDEX) and provides broking services to the clients. The Company also registered as Depository Participant with National
				Securities Depository Limited (NSDL), Central Depository Services (India) Limited (CDSL) and also registered as Repository Participant
				with National E-Repository Limited (NERL) and CDSL Commodity Repository Limited (CCRL). The Company is registered as Research Analyst
				with Securities and Exchange Board of India (SEBI) and Corporate agent (Composite) with Insurance Regulatory and Development Authority
				of India (IRDAI). The Company is registered as Point of Presence (PoP) under the National Pension System (NPS) with Pension Fund
				Regulatory and Development Authority and Real Estate Agent with Maharashtra Real Estate Regulatory Authority, Uttar Pradesh Real
				Estate Regulatory Authority, Haryana Real Estate Regulatory Authority Panchkula. The Company is also a distributor for various
				financial products such as and Mutual Funds, Bonds, NCD, PMS, Structured Products & Alternative Investment fund etc.
			</p>
			<div className={styles.reports}>
				{reports.map((report) => (
					<a
						className={styles.report}
						href={config.rootUrl + "ewwebimages/WebImages/Admin/" + report.FilePathName}
						key={report.ID}
						target="_blank"
					>
						<div className={styles.pdf_svg}>
							<PdfSvg width="51.586" height="66.5" viewbox="0 0 51.586 66.5" />
						</div>
						<p className={styles.agency}>Rating Agency</p>
						<h3 className={[styles.h3, styles.comp_name].join(" ")}>{report.RatingAgencyName}</h3>
						<p className={styles.link}>
							<i className="edel-icon-link" />
							View Report
						</p>
					</a>
				))}
			</div>
			<h2 className={styles.h1}>Investor Contacts</h2>
			{contactCard(investorContact)}
			<h3 className={styles.h2}>Debenture Trustees to the Issue</h3>
			{contactDebCard(DebTrustee)}
		</div>
	) : (
		<div style={{ textAlign: "center", paddingTop: "50px" }}>
			<Loader size={50} color="blue"></Loader>
		</div>
	);
};

export default StructuredProdScrn;
